import React from 'react';
import TabMenu from '../TabMenu';
import Spacing from '../Spacing';
import OverViewSection from '../Section/OverViewSection';
import GapsInCare from '../Section/GapsInCare';
import OverViewSection3 from '../Section/OverViewSection3';
const tabMenuData = [
  '7 days',
  '14 days',
  '1 month',
  '3 months',
  '6 months',
  '12 months',
];

export default function FrontdesksDashboard() {
  return (
    <>
      <h2 className="docpro_fs_24 docpro_mb_0">Today</h2>
      <Spacing lg="12" sm="12" />
      <OverViewSection3 />
      <Spacing lg="32" sm="32" />
      <h2 className="docpro_fs_24 docpro_mb_0">Clinic overview</h2>
      <TabMenu tabMenuData={tabMenuData} filter={true} />
      <Spacing lg="20" sm="20" />
      <OverViewSection />
      <Spacing lg="25" sm="25" />
      <GapsInCare />
    </>
  );
}
